const autoEmail = member => ({
  ...member, 
  email: member.email 
  ?? `${member.name.split(' ')[0].toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '')}@djavu.cl`,
});
export default [
  {
    name: 'Matías Soffia',
    role: 'Advisor',
    phrase: 'No pain, no gain.',
    pic: 'Matias.jpg',
  },
  {
    name: 'Daniel Aviv',
    role: 'CEO',
    phrase: 'Creo con convicción en el crecimiento personal como motor del crecimiento organizacional',
    pic: 'Daniel.jpg',
  },
  {
    name: 'Fernando Morales',
    role: 'CTO',
    phrase: '"Cuando vives para los demás, vives para ti mismo." ― Thriss, Nantuko Primus',
    pic: 'Nano.jpg',
  },
  {
    name: 'Jaime Sanz',
    role: 'Director',
    phrase: '"Si la implementación es difícil de explicar, es una mala idea. Si es fácil de explicar, puede que sea una buena idea." ― Zen de Python',
    pic: 'Jimbo.jpeg',
  },
  {
    name: 'Alfonso Basterrechea',
    role: 'PMO',
    phrase: '"La vida es como andar en bicicleta. Para mantener el equilibrio, debes seguir en movimiento" ― Albert Einstein',
    pic: 'Alfonso.jpg',
  },
  {
    name: 'Maximiliano Castro',
    role: 'Project Leader',
    phrase: 'El anhelo de un sueño debe convivir con disfrutar el vértigo del perseguirlo.',
    pic: 'Max.jpg',
    email: 'max@djavu.cl',
  },
  {
    name: 'Elisa Anguita',
    role: 'Project Leader',
    phrase: '"Todos sabemos algo. Todos ignoramos algo. Por eso, aprendemos siempre." ― Paulo Freire',
    pic: 'Elisa.jpeg',
  },
  {
    name: 'Nicolás Román',
    role: 'Project Leader',
    phrase: '"True magic results from courage of the heart. Boys and girls be ambitious. One step can change the world" ― Ken Akamatsu',
    pic: 'NicolasRman.jpg',
  },
  {
    name: 'Edson Reyes',
    role: 'Software Engineer',
    phrase: "\"There are 2 types of human beings in the world: those that shout Special Attacks and those that don't.\" — Sorachi Hideaki",
    pic: 'Edson.jpg',
  },
  {
    name: 'Pablo Pogorelow',
    role: 'Software Engineer',
    phrase: '"We are more than the parts that form us" — Patrick Rothfuss',
    pic: 'Ppogo.jpg',
  },
  {
    name: 'Ángel Urbina',
    role: 'Software Engineer',
    phrase: '"One must be sane to think clearly, but one can think deeply and be quite insane." ― Nikola Tesla',
    pic: 'Angel.jpg',
  },
  {
    name: 'Ariel Tirado',
    role: 'Software Engineer',
    phrase: '"A Future Is Not Given To You. It Is Something You Must Take For Yourself." - Pod 042',
    pic: 'Ariel.jpg',
  },
  {
    name: 'Andrés Espinoza',
    role: 'Software Engineer',
    phrase: 'La magia habita en las conexiones que nos hemos permitido sentir',
    pic: 'Andy.jpg',
  },
  {
    name: 'Daniel Méndez',
    role: 'Software Engineer',
    phrase: '"Sé curioso. Lee ampliamente. Prueba cosas nuevas. Lo que la gente llama inteligencia se reduce a sólo curiosidad." ― Aaron Swartz',
    pic: 'Crepu.jpg',
    email: 'danielm@djavu.cl',
  },
  {
    name: 'Alejandro González',
    role: 'Software Engineer',
    phrase: '"Las plegarias vienen del corazón. Si el corazón es fuerte, las emociones también lo serán. Y las emociones pueden manifestarse." - Isaac Netero.',
    pic: 'Alejandro.jpg',
  },
  {
    name: 'Luis Elgueda',
    role: 'HR Department',
    phrase: '"If you can not measure it, you can not improve it." ― W. Thomson',
    pic: 'Luis.jpg',
  },
].map(member => autoEmail(member));
